<template>
  <div class="login" style="display: flex; flex-flow: column; gap: 8px; width: 100%;">
    <div class="mb-3">
      <v-text-field v-model="login_id" label="ログインID" color="primary" variant="outlined" dense></v-text-field>
      <div class="text-right">
        <router-link replace :to="{ name: 'contentViewer', query: { page_uri: `/member/recover/login` } }"
          class="text-decoration-none">ログインIDをお忘れの方</router-link>
      </div>
    </div>
    <div class="mb-4">
      <v-text-field type="password" v-model="login_pw" label="パスワード" color="primary" variant="outlined" @keydown.enter="login" dense></v-text-field>
      <div class="text-right">
        <router-link replace :to="{ name: 'contentViewer', query: { page_uri: `/member/recover/pwd` } }"
          class="text-decoration-none">パスワードをお忘れの方</router-link>
      </div>
    </div>
    <div>
      <v-btn color="primary" :disabled="doingLogin" @click="login" block class="rounded-pill" size="large">{{ buttonLabel }}</v-btn>
    </div>
    <div v-if="errorMessage" class="text-center mt-3 py-3 bg-error-container">{{ errorMessage }}</div>
  </div>
  <v-dialog v-model="otpDialog" max-width="400" persistent>
    <v-card>
      <v-card-title class="d-flex">
        <span class="mr-auto">2段階認証</span>
        <v-btn icon @click="otpDialog = false" size="small" variant="flat">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <div v-if="otpErrorMessage" class="mb-2 py-2 px-3 bg-error-container">{{ otpErrorMessage }}</div>
        <p class="mb-4">
          {{ hiddenAddress }}へワンタイムパスワードを送信しました。<br>
          メール内に記載されているワンタイムパスワードを入力してください。
        </p>
        <v-text-field v-model="otp_code" label="ワンタイムパスワード" color="primary" variant="outlined" dense @keydown.enter="otpCheck"></v-text-field>
      </v-card-text>
      <div class="pt-0 px-5 pb-4">
        <v-btn color="primary" :disabled="checkingOtp" @click="otpCheck" block class="rounded-pill" size="large">{{ otpButtonLabel }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios"

export default {
  name: 'LoginForm',
  data() {
    return {
      login_id: '',
      login_pw: '',
      condition: '',
      doingLogin: false,
      buttonLabel: 'ログイン',
      errorMessage: '',
      otpDialog: false,
      otpDiablog_tokenkey: '',
      otpDiablog_token: '',
      hiddenAddress: '',
      otp_code: '',
      otpButtonLabel: '認証する',
      checkingOtp: false,
      otpErrorMessage: ''
    }
  },
  methods: {
    async login() {

      try {
        this.doingLogin = true;
        this.buttonLabel = '確認中...';
        this.errorMessage = '';

        self.condition = 'requesting';
        const xsrfResponse = await axios.post('/api/xsrf')

        console.log(xsrfResponse)

        self.condition = 'requesting';

        let payload = new URLSearchParams();
        payload.append(xsrfResponse.data.tokenKey, xsrfResponse.data.token)
        payload.append('login_id', this.login_id)
        payload.append('login_pw', this.login_pw)

        const loginresponse = await axios.post('/api/login', payload)

        console.log(loginresponse)
        if(loginresponse.data.need_otp_auth){
          this.doingLogin = false;
          this.buttonLabel = 'ログイン';
          this.hiddenAddress = loginresponse.data.hidden_email
          this.otpDialog = true
        }else{
          this.reload()
        }

      } catch (err) {
        console.log(err);
        this.doingLogin = false;
        this.buttonLabel = 'ログイン';
        this.condition = err.response.data.error_message;
        this.errorMessage = err.response.data.error_message;
      }
    },
    reload() {
      this.$router.go({ path: this.$router.currentRoute.path, force: true })
    },
    async otpCheck() {
      console.log('otpCheck');
      try{
        this.checkingOtp = true;
        this.otpErrorMessage = '';
        this.otpButtonLabel = '確認中...';
        const xsrfResponse = await axios.post('/api/xsrf')

        let payload = new URLSearchParams();
        payload.append(xsrfResponse.data.tokenKey, xsrfResponse.data.token)
        payload.append('otp_code', this.otp_code)

        const response = await axios.post('/api/otp-check', payload)
        console.log(response)
        this.reload()
      }catch(err){
        console.log(err);
        this.checkingOtp = false;
        this.otpButtonLabel = '認証する';
        this.otpErrorMessage = err.response.data.error_message;
      }
    }
  }
}
</script>

<style scoped>
.login {
  margin: auto;
  box-sizing: border-box;
}

input {
  width: 100%;
}
</style>